// Factories
import { BaseStoreLoader } from "../../base/loaders/BaseStoreLoader";
/**
 * Loader class for store providers in Web app
 */
export class WebStoreLoader extends BaseStoreLoader {
    // TODO ADO#9153353 - We only need to do this while we don't have AFD mapping
    getRouteStorePathPrefix() {
        return this.configProvider().runtimeConfig.activeWebUrlPrefix;
    }
}
